<template>
  <div class="alarm-page" id="app">
    <mt-header
        fixed
        :title="'流程台账'"
    >
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div class="alarm" v-show="!$store.getters.details">
      <div class="alarm-search">
        <div :class="{ closeAlarmSearch: !isOpen, openAlarmSearch: isOpen }">
          <mt-cell label="类型">
            <mt-field
                placeholder="请输入~"
                v-model="param.typeNmae"
                disableClear
                @blur.native.capture="search"
            ></mt-field>
          </mt-cell>
          <mt-cell label="审核人">
            <mt-field
                placeholder="请输入~"
                v-model="param.shenuser"
                disableClear
                @blur.native.capture="search"
            ></mt-field>
          </mt-cell>
          <div class="ctrl"></div>
          <mt-cell
              label="状态"
              is-link
              @click.native="statusVisible = true"
          >
            <span
                :style="!param.statusId ? `color: #999` : `color: black`"
            >{{
                !param.statusName ? "全部" : param.statusName
              }}</span
            >
          </mt-cell>
          <div class="ctrl"></div>
          <mt-cell label="申请时间" @click.native="selectDatetime">
            <div>{{ param.applyTime }}</div>
            <img
                style="width: 2rem; padding-right: 0.5rem"
                v-if="!param.applyTime"
                src="@/assets/icons/svg/dateChoose.svg"
            />
            <div class="mint-field-clear" v-else @click.stop="clearHandel">
              <i class="mintui mintui-field-error"></i>
            </div>
          </mt-cell>
          <div class="ctrl"></div>
        </div>
        <div class="open" @click="setOpen">
          <div class="text">{{ !isOpen ? "点击搜索" : "点击收起" }}</div>
          <div class="icon"></div>
        </div>
      </div>
      <div class="alarm-list" :style="[{ height: isOpen ? '75%' : '86%' }]">
        <mt-loadmore
            :bottom-all-loaded="allLoaded"
            ref="loadmore"
        >
          <ul
              infinite-scroll-disabled="loading"
              infinite-scroll-distance="10"
          >
            <div
                class="alarm-list-item"
                v-for="(item, idx) in dataList"
                :key="idx"
                @click="itemClick(item)"
            >
              <div class="alarm-list-item-text2">
                <span class="alarmTime_lable"> 类型： </span>
                <span class="alarm-list-item-text-title">{{ item.typeNmae }}</span>
              </div>
              <div class="alarm-list-item-text2" v-if="item.shenuser!=null">
                <span class="alarmTime_lable"> 审核人： </span>
                <span class="alarm-list-item-text-title">{{ item.shenuser }}</span>
              </div>
              <div class="alarm-list-item-text2">
                <div class="alarm-list-item-text-alarmContent">
                  <div>
                    <span class="alarmTime_lable"> 申请时间： </span>
                    <span class="alarm-list-item-text-title">{{ item.applyTime }}</span>
                  </div>
                </div>
                <div
                    class="alarm-list-item-text-stutas"
                    :class="item.statusId == 26 ? 'nopass' : 'feedBack'"
                >
                  <span :class="item.statusId == 26 ? 'nopassfont' : ''">{{ item.statusName }}</span>
                </div>
              </div>
              <div class="alarm-list-item-text" v-if="item.statusId ==23 ||item.statusId ==24">
                <div class="alarm-list-item-text-title">
                  <div class="buttonClass" @click.prevent="appSendProSms(item)">发送短信</div>
                </div>
              </div>
              <div class="alarm-list-item-text" v-if="item.statusId ==26 || item.statusId ==22">
                <div class="alarm-list-item-text-title" style="display: flex; gap: 8px;">
                  <div class="buttonClass" @click.prevent="appUpdateProcedure(item)">修改</div>
                  <div class="buttonClass" @click.prevent="appDeleteProcedure(item)">删除</div>
                </div>
              </div>
            </div>
          </ul>
        </mt-loadmore>
        <div class="no-data" v-if="dataList.length < 1">
          <img class="noData_img" src="@/assets/icons/svg/noData.svg" />
          暂无数据
        </div>
      </div>
    </div>
    <!-- 状态选择 -->
    <mt-popup
        style="width: 100%"
        v-model="statusVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="statusVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectStatusPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="statusList"
          ref="statusList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
    <!-- 时间区间选择 -->
    <van-calendar
        v-model="DatetimeVisible"
        type="single"
        :min-date="minDate"
        :max-date="new Date()"
        @confirm="onConfirm"
    >
    </van-calendar>
  </div>
</template>

<script>
import {Indicator, Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from 'axios';
import request from "@/utils/keyCloakRequest";
export default {
  mounted() {
    var that = this;
    that.isOpen = true;
    that.getDataList();
  },
  async created() {
  },
  data() {
    return {
      statusList:[
        {
          values: [
            {
              code: "",
              name: "全部"
            },
            {
              code: "23",
              name: "未处理"
            },
            {
              code: "24",
              name: "处理中"
            },
            {
              code: "25",
              name: "已批准"
            },
            {
              code: "26",
              name: "未通过"
            },
            {
              code: "27",
              name: "归档"
            }
          ],
          className: "slot1"
        }
      ],
      statusVisible: false,
      isOpen: false,
      //----------//
      dataList: [], // 展示的数据
      loading: false, // 上拉加载
      dataForm: {
        value: undefined
      },
      minDate: new Date(2024, 11, 1),
      maxDate: new Date(),
      param: {
        userId: JSON.parse(getLocalData("userInfo")).userId,
        applyTime: undefined,
        statusName: undefined,
        statusId: undefined,
        shenuser: undefined,
        typeNmae: undefined,
      },
      isLoading: false,
      allLoaded: false,
      DatetimeVisible: false,
      visible: false,
    };
  },
  watch:{
  },
  methods: {
    selectStatusPicker() {
      this.param.statusId = this.$refs.statusList.getValues()[0].code;
      this.param.statusName =  this.$refs.statusList.getValues()[0].name;
      this.statusVisible = false;
      this.search();
    },
    // 清除时间
    clearHandel(e) {
      if (this.param.applyTime) {
        this.clearTimeAll();
      }
    },
    appSendProSms(item){
      this.visible = true
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSendProSms?id="+item.processId,
      }).then(res => {
        this.getDataList()
        Toast({
          message: "发送成功",
          position: 'middle',
          iconClass: "icon icon-success"
        });
      })
    },
    appUpdateProcedure(item){
      this.visible = true
      if(item.typeNmae=='请假申请'){
        this.$router.push({
          name: "addHoliday",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='公务用车申请'){
        this.$router.push({
          name: "addOfficialVehicles",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='车辆维修申请'){
        this.$router.push({
          name: "addRepairVehicle",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='用印申请'){
        this.$router.push({
          name: "addUseSeal",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='印章外出申请'){
        this.$router.push({
          name: "addOutSeal",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='物品采购申请'){
        this.$router.push({
          name: "apppurchased",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='物品领用申请'){
        this.$router.push({
          name: "appreceived",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
      else if(item.typeNmae=='加班/调休申请'){
        this.$router.push({
          name: "addOverTime",
          query: {
            item: item,
            route:'/procedure/procedureList'
          },
        });
      }
    },
    appDeleteProcedure(item){
      this.visible = true
        axios({
        url: process.env.VUE_APP_SSO_URL+"appDeleteProcedure",
        method: "POST",
        data: {'processId':item.processId,'typeNmae':item.typeNmae}
      }).then(res => {
        this.getDataList()
        Toast({
          message: "删除成功",
          position: 'middle',
          iconClass: "icon icon-success"
        });
      })
    },
    itemClick(item) {
      if(!this.visible){
        if(item.typeNmae=='请假申请'){
          this.$router.push({
            name: "holidayListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='公务用车申请'){
          this.$router.push({
            name: "officialVehiclesListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='车辆维修申请'){
          this.$router.push({
            name: "repairVehicleListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='用印申请'){
          this.$router.push({
            name: "useSealListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='印章外出申请'){
          this.$router.push({
            name: "outSealListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='物品采购申请'){
          this.$router.push({
            name: "purchasedListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='物品领用申请'){
          this.$router.push({
            name: "receivedListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else if(item.typeNmae=='加班/调休申请'){
          this.$router.push({
            name: "overTimeListDetail",
            query: {
              item: item,
              route:'/procedure/procedureList'
            },
          });
        }
        else {
          alert(item.typeNmae)
        }
      }
    },
    setOpen() {
      this.isOpen = !this.isOpen;
    },
    selectDatetime() {
      this.DatetimeVisible = true;
    },
    //确认选择时间区间
    onConfirm(value) {
      this.param.applyTime = this.formatDate(value);
      this.DatetimeVisible = false
      this.search();
    },
    //清除选择时间区间
    clearTimeAll() {
      this.param.applyTime = "";
      this.search();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month =
          date.getMonth() + 1 > 9
              ? date.getMonth() + 1
              : `0${date.getMonth() + 1}`;
      const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      return `${year}-${month}-${day}`;
    },
    // 初始化
    getDataList() {
      var that = this;
      that.isLoading = true; // 关闭下拉刷新数据，避免重复请求
      Indicator.open("加载中...");
      axios({
        url: process.env.VUE_APP_SSO_URL+"appProcedureList",
        method: "POST",
        data:this.param
      }).then(response => {
        this.dataList = response.data
        that.allLoaded = true;
        Indicator.close();
      })
    },
    goBack() {
      this.$router.push("/home");
    },
    // 模糊查询
    search() {
      var that = this;
      that.getDataList();
    }
  }
};
</script>
<style lang="less" scoped>
body {
  display: block;
  margin: 0rem !important;
}
.alarm-page {
  width: 100%;
  height: 100vh;
  background-color: #f8f8f8;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: hidden;
}
.mint-header {
  background-color: #4385f4 !important;
  border-bottom: 1px solid #37373724;
}
.top-bg {
  width: 100%;
  height: 5rem;
  background-color: #4385f4;
}
.alarm {
  height: 100%;
  // top: -10rem;
  position: relative;
}
.alarm-list {
  padding: 0 1rem;
  position: relative;
  top: 0;
  height: 100%;
  overflow-y: scroll;
}
.alarm-list-head {
  color: #999;
}
.alarm-list-item {
  margin: 0.5rem 0;
  padding: 0.25rem;
  font-size: 1rem;
  min-height: 5rem;
  line-height: 1.5rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-left: 0.25rem solid #4385f4;
  border-radius: 0.2rem;
}
.buttonClass{
  width: 520px;
  height: 110px;
  line-height: 100px;
  font-size: 80px;
  background: #5f9cf5;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #f9e5e5;
  margin-top: 10px
}
.alarm-list-item-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #f5f5f5;
}
.alarm-list-item-text-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9rem;
  font-weight: bolder;
}
.alarm-list-item-text-dangsrcName {
  margin-left: 0.1rem;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #4385f4;
  height: 1.25rem;
  line-height: 1.25rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  font-weight: bolder;
}
.alarm-list-item-text2 {
  font-size: 0.7rem;
  margin-top: 0.5rem;
  display: flex;
  // flex-direction: column;
  // justify-content: center;
  min-height: 2rem;
  align-items: center;
  .left {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
.alarm-list-item-text-alarmContent {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
}
.isNotCheck {
  background: #e5ebff !important;
  border: 1px solid #077efa !important;
  color: green !important;
}
.isCheck{
  background: #e5ebff !important;
  border: 1px solid #077efa !important;
  color: #4385f4 !important;
}
.nopassfont{
  font-weight: 600;
}
.alarm-list-item-text-stutas {
  width: 20%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  background: #fdf1e8;
  border: 1px solid #ff5f00;
  color: #ff5f00;
  height: 1.5rem;
  line-height: 1.5rem;
  border-radius: 0.25rem;
  margin-left: 0.1rem;
  text-align: center;
}
.feedBack {
  background: #e5ebff !important;
  border: 1px solid #077efa !important;
  color: #4385f4 !important;
}
.nopass{
  background: #e5ebff !important;
  border: 1px solid #077efa !important;
  color: red !important;
}
.closeAlarmSearch {
  height: 0px;
  overflow: hidden;
}
.openAlarmSearch {
  height: 100%;
}
.alarm-search {
  margin-top: 2.5rem;
  top: -4.8rem;
  background: #fff;
  z-index: 100;
  .open {
    display: flex;
    height: 2.5rem;
    line-height: 2rem;
    justify-content: center;
    align-items: center;
    .text {
      color: #4385f4;
      font-size: 0.8rem;
    }
    .icon {
      margin-left: 0.366667rem;
      border-bottom: 0.533333rem solid #666;
      border-left: 0.533333rem solid #fff;
      border-right: 0.533333rem solid #fff;
      width: 0px;
      height: 0px;
    }
  }
  .close {
    display: flex;
    height: 2.5rem;
    line-height: 2rem;
    justify-content: center;
    align-items: center;
    .text {
      color: #4385f4;
      font-size: 0.8rem;
    }
    .icon {
      margin-left: 0.366667rem;
      border-top: 0.533333rem solid #666;
      border-left: 0.533333rem solid #fff;
      border-right: 0.533333rem solid #fff;
      width: 0px;
      height: 0px;
    }
  }
}
.alarm-search-input {
  width: 95%;
  height: 1.3rem;
  padding: 0.3rem;
  border: 1px solid #000;
  border-radius: 0.3rem;
}
.alarm-search-button {
  align-self: center;
  justify-self: center;
}
.btn-grey {
  background: #999;
}
.no-data {
  top: 30%;
  position: absolute;
  left: 25%;
  width: 50%;
  display: block;
  color: #999;
  text-align: center;
  font-size: 1rem;
}
.noData_img {
  width: 100%;
  padding-bottom: 2rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
</style>
